import { Controller } from "@hotwired/stimulus"

// Clears the selected radio in the form and submits. Use with a button:
// data-controller="radio-reset" data-action="click->radio-reset#reset"
// data-radio-reset-name-value="user_additional_information[information]"
export default class extends Controller {
  static values = {
    name: { type: String, default: "user_additional_information[information]" }
  }

  reset(event) {
    event.preventDefault()
    const form = this.element.closest("form")
    if (!form) return

    const selector = `input[type="radio"][name="${this.nameValue}"]`
    form.querySelectorAll(selector).forEach((radio) => {
      radio.checked = false
    })

    form.requestSubmit()
  }
}
